import axios from '../axios';

export default {
  getAdminCodes: (id) => axios.get(`/doorphone/${id}/main-setups`),
  getSipStatus: (id) => axios.put(`/doorphone/${id}/sip-status`),
  saveAdminCodes: (id, codesData) => axios.post(`/doorphone/${id}/main-setups`, codesData),
  updateAdminCode ({ doorphoneId, code }) {
    return new Promise((resolve, reject) => {
      axios.post(`/doorphone/${doorphoneId}/main-setups/code`, {
        admin_code: code,
      })
        .then(response => {
          if (response.data.errors && response.data.errors.length > 0) {
            reject(response.data.errors);
          } else {
            resolve(response.data);
          }
        })
        .catch(err => reject(err));
    });
  },
  updateMassAdminCode ({ adminCode, doorphones }) {
    return new Promise((resolve, reject) => {
      axios.post('/main-setups/code', {
        admin_code: adminCode,
        doorphones,
      })
        .then(response => {
          resolve(response);
        })
        .catch(err => reject(err));
    });
  },
  importCodesFromDoorphone (id) {
    return new Promise((resolve, reject) => {
      axios.post(`/doorphone/${id}/main-setups/import`)
        .then(response => {
          resolve(response);
        })
        .catch(err => reject(err));
    });
  },
  updateMassConciergeNumber ({ conciergeNumber, doorphones }) {
    return new Promise((resolve, reject) => {
      axios.post('/main-setups/concierge-number', {
        concierge_number: conciergeNumber,
        doorphones,
      })
        .then(response => {
          resolve(response);
        })
        .catch(err => reject(err));
    });
  },
  getAdminPassword: (id) => axios.get(`/doorphone/${id}/main-setups/admin-password`),
  updateAdminPassword (id, adminPassword) {
    return new Promise((resolve, reject) => {
      axios.put(`/doorphone/${id}/main-setups/admin-password`, { admin_password: adminPassword })
        .then(response => {
          resolve(response);
        })
        .catch(err => reject(err));
    });
  },
};
